var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHomeLight = function SvgIconHomeLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_home_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.69 12.74a2.38 2.38 0 0 0-3.104.02l-9.41 7.508c-.644.5-.976 1.186-.976 1.932v11.3c0 1.392 1.107 2.5 2.5 2.5h18.8c1.375 0 2.516-1.096 2.6-2.53V22.2c0-.746-.332-1.431-.975-1.932l-.011-.008-9.4-7.5a.97.97 0 0 1-.024-.02Zm1.408-1.69a4.58 4.58 0 0 0-5.896 0l-9.383 7.486C10.666 19.436 10 20.75 10 22.2v11.3c0 2.608 2.092 4.7 4.7 4.7h18.8c2.617 0 4.67-2.091 4.799-4.645l.001-.055V22.2c0-1.451-.666-2.764-1.819-3.664l-9.383-7.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.711 29.224a.21.21 0 0 0-.011.076V36h4.8v-6.7a.21.21 0 0 0-.015-.085.21.21 0 0 0-.085-.015h-4.6a.21.21 0 0 0-.085.015.057.057 0 0 0-.004.009ZM27.6 37.1h1.1v-7.8c0-1.308-.992-2.3-2.3-2.3h-4.6c-1.308 0-2.3.992-2.3 2.3v7.8a1.1 1.1 0 0 0 1.1 1.1h7v-1.1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_home_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h28.2v28.2H0z"
  })))));
};
export default SvgIconHomeLight;